// src/pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import { getUserInventoriesCreator } from "../../services/inventoryServices";
import { getAllBrands } from "../../services/brandsServices";
import { getVentasResumen } from "../../services/dashboards";
import DashboardFilters from "../Graphics/DashboardFilters";
import DashboardChart from "../Graphics/DashboardChart";
import DashboardMaxExistenciasChart from "../Graphics/DashboardMaxExistenciasChart";
import DashboardMinExistenciasChart from "../Graphics/DashboardMinExistenciasChart";
import DashboardTopSelling from "../Graphics/DashboardTopSelling";
import '../../styles/DashboardGraphics.css'

export default function Dashboard() {
  const [inventarios, setInventarios] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [data, setData] = useState([]);

  const [inventarioSelected, setInventarioSelected] = useState(null);
  const [marcaSelected, setMarcaSelected] = useState(0);
  const [fechaInicio, setFechaInicio] = useState("2025-05-01");
  const [fechaFin, setFechaFin] = useState("2025-06-03");

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const [inv, marcasData] = await Promise.all([
          getUserInventoriesCreator(),
          getAllBrands()
        ]);
        setInventarios(inv);
        setMarcas(marcasData);
        if (inv.length > 0) setInventarioSelected(inv[0].FIInventario);
      } catch (err) {
        console.error("Error cargando filtros:", err);
      }
    };
    fetchFilters();
  }, []);

  useEffect(() => {
    const fetchResumen = async () => {
      if (!inventarioSelected) return;
      try {
        const resumen = await getVentasResumen({
          inventario: inventarioSelected,
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin,
          marca: marcaSelected
        });
        setData(resumen);
      } catch (err) {
        console.error("Error al cargar ventas:", err);
      }
    };
    fetchResumen();
  }, [inventarioSelected, marcaSelected, fechaInicio, fechaFin]);

  return (
    <div className="p-6">
      <DashboardFilters
        inventarios={inventarios}
        marcas={marcas}
        inventarioSelected={inventarioSelected}
        setInventarioSelected={setInventarioSelected}
        marcaSelected={marcaSelected}
        setMarcaSelected={setMarcaSelected}
        fechaInicio={fechaInicio}
        setFechaInicio={setFechaInicio}
        fechaFin={fechaFin}
        setFechaFin={setFechaFin}
      />
      <DashboardChart data={data} />
      <div className="flex flex-col lg:flex-row gap-6 mt-6">
        <DashboardMaxExistenciasChart inventarioSelected={inventarioSelected} />
        <DashboardMinExistenciasChart inventarioSelected={inventarioSelected} />
      </div>
<DashboardTopSelling inventarioId={inventarioSelected} />
    </div>
  );
}
